module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (81).ae8f25b6.jpg";